<template>
    <fieldset :disabled="!isEditing.value">
        <div class="title bg-success">WhatsappSystem</div>

        <div class="col-md-6">
            <label for="nome" class="col-form-label">Sistema</label>
            <SearchableSelect v-if="isEditing.value" :initial-selected-item="whatsappSystem.system" :items="systemsOptions" placeholder="Selecione o sistema de envio" 
            @item-selected="(value)=> whatsappSystem.system = value" />
        </div>
        
        <div class="col-md-6">
            <label for="ucname" class="col-form-label">URL</label>
            <input v-model="whatsappSystem.url" id="site" class="form-control">
        </div>

        <div class="col-md-6">
            <label for="ucname" class="col-form-label">Token</label>
            <input v-model="whatsappSystem.token" id="site" class="form-control">
        </div>
        <button v-if="isEditing.value" type="button" class="actions btn btn-primary btn-sm" @click="saveWhatsappSystem">
            Salvar
        </button>
    </fieldset>
</template>

<script>
import useEditMode from "@/services/EditingService";
import SearchableSelect from "@/components/SearchableSelect.vue";
import { whatsappSystemService } from "@/services/backend/ApiService";

export default {
    components: {
        SearchableSelect
    },
    data() {
        return {
            whatsappSystem: Object,
            systemsOptions: []
        };
    },
    setup() {
        const isEditing = useEditMode();

        return { isEditing };
    },
    methods: {
        async saveWhatsappSystem() {
            await whatsappSystemService.update(this.whatsappSystem.id, this.whatsappSystem);
        },
    },
    async mounted() {
        const whatsappSystemId = this.$route.params.id;
        this.systemsOptions = [{
            value: "wa",
            option: "wa"
        }]

        if (whatsappSystemId) {
            this.whatsappSystem = await whatsappSystemService.findOne(whatsappSystemId);
        }
    }
};
</script>


<style scoped>
select {
    margin-bottom: 30px
}

option[disabled] {
    background: rgb(221, 221, 221);
}
</style>
